var r=["SPC_U","SPC_F","SPC_T_ID","SPC_T_IV"];function n(n){var t={};if("function"==typeof n)for(var _=n(),f=0,o=r;f<o.length;f++){var a=o[f];t[a]=_[a]}return t}export{n as getSiteCookies};
